import api from "api";
import LayoutItem from "components/LayoutItem";
import React, { useState, useEffect } from "react";
import { Modal } from "reactstrap";
import { Button } from "shared";
import t, { getCurrentLanguage } from "utils/Lang";

type ModalCreateGroupProps = {
  isOpen: boolean;
  toggle: (event?: React.KeyboardEvent<any>) => void;
  id?: number;
  user: any;
  onClosed: () => void;
  tab: any;
  selectedGroupId?: any;
  onCreated: (data: any) => void;
  onUpdated: (data: any) => void;
};

const ModalCreateGroup = ({
  isOpen,
  toggle,
  user,
  onClosed,
  tab,
  selectedGroupId,
  onCreated,
  onUpdated,
}: ModalCreateGroupProps) => {
  const [groupData, setGroupData] = useState<any>({
    content_type: "site",
    is_active: true,
    scope: "custom",
    is_view_only: false,
    is_show: true,
  });
  useEffect(() => {
    if (selectedGroupId) {
      fetchGroupDetail();
    } else {
      setGroupData({
        content_type: "site",
        is_active: true,
        scope: "custom",
        is_view_only: false,
        is_show: true,
      });
    }
  }, [selectedGroupId]);
  const fetchGroupDetail = async () => {
    const res = await api.getGroupDetail(selectedGroupId);
    if (res.status === "ok") {
      setGroupData((data: any) => ({
        ...data,
        name: res?.studio_group?.languages?.vi,
        name_en: res?.studio_group?.languages?.en,
        is_show: res?.studio_group?.is_show,
      }));
    }
  };
  const uiLayoutDefinition = [
    {
      attributeName: "brand",
      type: "text",
      data: user?.user_brand?.brand_name,
      label: "Brand",
      disabled: true,
    },
    {
      attributeName: "studio_tab",
      type: "text",
      data: tab.name,
      label: "Studio Tab",
      disabled: true,
    },
    {
      attributeName: "name",
      type: "text",
      label: "Group name (*)",
    },
    {
      attributeName: "name_en",
      type: "text",
      label: "Group name (en)",
    },
    {
      attributeName: "is_show",
      type: "check",
      label: "Show group",
    },
  ];
  const onSave = async () => {
    if (!groupData.name) {
      alert("Group name can not be empty");
      return;
    }
    const data = {
      name: groupData.name,
      studio_tab_id: parseInt(tab.id),
      languages: {
        vi: groupData.name,
        en: groupData.name_en,
      },
      is_show: groupData.is_show,
    };
    if (selectedGroupId) {
      const res = await api.updateGroup(data, selectedGroupId);
      onUpdated({
        id: selectedGroupId,
        name: data.languages[getCurrentLanguage() || "vi"],
        is_show: groupData.is_show,
      });
    } else {
      const res = await api.createGroup(data);
      onCreated(res?.studio_group);
    }
    toggle();
  };

  const updateAtt = (att: string, val: any) => {
    let value = val;
    if (typeof val === "object") {
      if (val?.length > 0) {
        // good
      } else {
        value = val.value;
      }
    }
    setGroupData((dt: any) => {
      if (dt) {
        return {
          ...dt,
          [att]: value,
        };
      }
      return { [att]: value };
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      style={{ padding: 30 }}
      onClosed={onClosed}
    >
      <div className="modal-custom-field__header">
        <span className="modal-custom-field__header__title">
          {selectedGroupId
            ? t().modal_create_group__edit_group
            : t().modal_create_group__create_group}
        </span>
        <i className="material-icons btn-close" onClick={() => toggle()}>
          close
        </i>
      </div>
      <div className="modal-custom-field__body">
        {uiLayoutDefinition.map((item) => (
          <LayoutItem
            key={item.attributeName}
            item={item}
            statusData={groupData}
            callback={updateAtt}
          />
        ))}
      </div>
      <div className="modal-custom-field__footer">
        <Button
          label={t().action__done}
          onClick={onSave}
          size="small"
          type="primary"
        />
      </div>
    </Modal>
  );
};

export default ModalCreateGroup;
